import { addNewUserValidations } from 'src/views/pages/manageUser/NewUser/Body/Form/validations';
import Dealership from 'src/views/pages/manageUser/NewUser/Body/Form//Dealership/Dealership';
import Input from 'src/components/forms/input';
import { IUser } from 'src/utils/interfaces/user';
import { IUserData } from './../../Body';
import Spinner from 'src/components/ui/spinner/index';
import { useFormik } from 'formik';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import {
    addHyphens,
    getPermissionsObj,
    onKeyPressPhoneHandler,
} from 'src/views/pages/manageUser/NewUser/Body/Form/Form';
import {
    DealerAssociation,
    DealerPermission,
} from 'src/services/models/dealer-management.service';
import {
    DealerManagementService,
    IEditDealerUserPayload,
} from 'src/services/dealer-management.service';
import React, { Dispatch, SetStateAction, useState } from 'react';

import './styles.scss';

const EMPTY_ARRAY_SIZE = 0;
interface IFormProps {
    userData: IUserData;
    setIsErrorNotification: Dispatch<SetStateAction<boolean>>;
    setIsSuccessNotification: Dispatch<SetStateAction<boolean>>;
    dealerPermissions: Array<DealerPermission>;
    dealerAssociations: Array<DealerAssociation>;
    getDealerUserData: Function;
    isUserActive: boolean;
    isDSMSearch?: boolean;
    setSuccessNotificationMessage: Dispatch<SetStateAction<string>>;
    setErrorNotificationMessage: Dispatch<SetStateAction<string>>;
}

const Form: React.FC<IFormProps> = ({
    userData,
    setIsErrorNotification,
    setIsSuccessNotification,
    dealerPermissions,
    dealerAssociations,
    getDealerUserData,
    isUserActive,
    setSuccessNotificationMessage,
    setErrorNotificationMessage,
    isDSMSearch = false,
}) => {
    const { initialDealerships, initialPermissionsMap } =
        mapDealershipsPermissions(userData);
    const { dealerDataInfo, dealerGroupState } = useSelector((state: IUser) => {
        return state;
    });
    const brand: string = dealerDataInfo?.dealer.brand || 'vw';

    const [submitErrors, setSubmitErrors] = useState({
        email: '',
        phone: '',
        firstName: '',
        lastName: '',
    });
    const [selectedDealerships, setSelectedDealerships] =
        useState<Array<string>>(initialDealerships);
    const [loading, setLoading] = useState<boolean>(false);
    const [permissionsMap, setPermissionsMap] = useState<
        Map<string, Array<string>>
    >(initialPermissionsMap);
    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        handleBlur,
        setFieldValue,
    } = useFormik({
        initialValues: {
            email: userData.email,
            phone: addHyphens(userData.phone),
            firstName: userData.firstName,
            lastName: userData.lastName,
        },
        validationSchema: addNewUserValidations,
        onSubmit: handlerSubmit,
    });
    const { addNewUser, editUser } = useLocalization();

    async function handlerSubmit(): Promise<void> {
        const permissionsObj = getPermissionsObj(permissionsMap, undefined);
        setLoading(true);
        setIsErrorNotification(false);
        setErrorNotificationMessage(editUser.NOTIFICATION_ERROR_REQUEST);
        setSubmitErrors({
            email: '',
            phone: '',
            firstName: '',
            lastName: '',
        });
        if (
            permissionsObj.permissions.length > EMPTY_ARRAY_SIZE &&
            permissionsObj.associations.length > EMPTY_ARRAY_SIZE
        ) {
            const service = new DealerManagementService();
            const country =
                dealerGroupState &&
                dealerGroupState[0]?.dealers[0]?.country === 'US'
                    ? 'USA'
                    : 'Canada';
            const request = {
                firstName: values.firstName.trim(),
                lastName: values.lastName.trim(),
                emailAddress: values.email.toLowerCase(),
                currentEmailAddress: userData.email.toLowerCase(),
                userId: userData.userId,
                phoneNumber: values.phone.replace(/\D/g, ''),
                country: country || '',
                newPermissions: permissionsObj.permissions,
                newAssociations: permissionsObj.associations,
            };
            try {
                await service.editUser(request as IEditDealerUserPayload);
                await getDealerUserData(true);
                setLoading(false);
                setSuccessNotificationMessage(
                    editUser.NOTIFICATION_SUCCESS_REQUEST,
                );
                setIsSuccessNotification(true);
            } catch (error) {
                setLoading(false);
                setIsErrorNotification(true);
            }
        } else {
            setLoading(false);
            setIsErrorNotification(true);
        }
    }

    const onChangePhoneHandler = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const formattedPhone = addHyphens(event.target.value);
        setFieldValue(event.target.name, formattedPhone);
    };

    const isEdited = (): boolean => {
        return (
            values.email !== userData.email ||
            values.firstName !== userData.firstName ||
            values.lastName !== userData.lastName ||
            values.phone.replace(/\D/g, '') !==
                userData.phone.replace(/\D/g, '') ||
            initialDealerships.length !== selectedDealerships.length ||
            !compareMaps(initialPermissionsMap, permissionsMap)
        );
    };

    const onDiscardHanlder = (event: any) => {
        event.preventDefault();
        setPermissionsMap(new Map(initialPermissionsMap));
        setSelectedDealerships([...initialDealerships]);
        values.email = userData.email;
        values.firstName = userData.firstName;
        values.lastName = userData.lastName;
        values.phone = addHyphens(userData.phone);
    };

    return (
        <form
            className={'edit-user-container__profile--form'}
            onSubmit={handleSubmit}
        >
            <Input
                labelName={addNewUser.FORM_LABEL_FIRSTNAME}
                type={'text'}
                name={'firstName'}
                handlerChange={handleChange}
                handlerBlur={handleBlur}
                value={values.firstName}
                asErrors={errors.firstName}
                asTouched={touched.firstName}
                asSubmitError={submitErrors.firstName}
                disabled={!isUserActive}
            />
            <Input
                labelName={addNewUser.FORM_LABEL_LASTNAME}
                type={'text'}
                name={'lastName'}
                handlerChange={handleChange}
                handlerBlur={handleBlur}
                value={values.lastName}
                asErrors={errors.lastName}
                asTouched={touched.lastName}
                asSubmitError={submitErrors.lastName}
                disabled={!isUserActive}
            />
            <Input
                labelName={addNewUser.FORM_LABEL_PHONE}
                type={'text'}
                name={'phone'}
                maxlength={12}
                handlerChange={onChangePhoneHandler}
                handlerBlur={handleBlur}
                value={values.phone}
                asErrors={errors.phone}
                asTouched={touched.phone}
                asSubmitError={submitErrors.phone}
                handleKeyPress={onKeyPressPhoneHandler}
                disabled={!isUserActive}
            />
            <Input
                labelName={addNewUser.FORM_LABEL_EMAIL}
                type={'text'}
                name={'email'}
                maxlength={50}
                handlerChange={handleChange}
                handlerBlur={handleBlur}
                value={values.email}
                asErrors={errors.email}
                asTouched={touched.email}
                asSubmitError={submitErrors.email}
                disabled={!isUserActive}
            />
            <Dealership
                selectedDealerships={selectedDealerships}
                onSelectDealerships={setSelectedDealerships}
                permissionsMap={permissionsMap}
                setPermissionsMap={setPermissionsMap}
                dealerPermissionsFromToken={dealerPermissions}
                dealerAssociationsFromToken={dealerAssociations}
                initialDealerships={initialDealerships}
                disabled={!isUserActive}
                isDSMSearch={isDSMSearch}
            />
            <div className='edit-user--form_button-ct'>
                <button
                    className={`edit-user--form_button secondary c-btn ${brand.toLowerCase()}`}
                    disabled={
                        values.email === '' ||
                        values.firstName === '' ||
                        values.lastName === '' ||
                        values.phone === '' ||
                        !!Object.keys(errors).length ||
                        !Object.keys(selectedDealerships).length ||
                        !Array.from(permissionsMap.values()).some(
                            (perms) => perms.length > EMPTY_ARRAY_SIZE,
                        ) ||
                        loading ||
                        !isUserActive ||
                        !isEdited()
                    }
                    type={'button'}
                    onClick={onDiscardHanlder}
                >
                    <span className='c-btn__text'>
                        {editUser.BUTTON_DISCARD_LABEL}
                    </span>
                </button>
                <button
                    className={`edit-user--form_button c-btn ${brand.toLowerCase()}`}
                    disabled={
                        values.email === '' ||
                        values.firstName === '' ||
                        values.lastName === '' ||
                        values.phone === '' ||
                        !!Object.keys(errors).length ||
                        !Object.keys(selectedDealerships).length ||
                        !Array.from(permissionsMap.values()).some(
                            (perms) => perms.length > EMPTY_ARRAY_SIZE,
                        ) ||
                        loading ||
                        !isUserActive ||
                        !isEdited()
                    }
                    type={'submit'}
                >
                    <span className='c-btn__text'>
                        {loading ? <Spinner /> : editUser.BUTTON_SAVE_LABEL}
                    </span>
                </button>
            </div>
        </form>
    );
};

function mapDealershipsPermissions(userData: IUserData): {
    initialDealerships: Array<string>;
    initialPermissionsMap: Map<string, Array<string>>;
} {
    const initialDealerships: Array<string> = [];
    const initialPermissionsMap: Map<string, Array<string>> = new Map();

    for (const permission of userData.userPermissions) {
        const dealerId = permission.dealerId;
        if (dealerId) {
            if (!initialDealerships.includes(dealerId)) {
                initialDealerships.push(dealerId);
            }
            const mapItem = initialPermissionsMap.get(dealerId);
            if (mapItem) {
                mapItem.push(permission.permission);
            } else {
                initialPermissionsMap.set(dealerId, [permission.permission]);
            }
        }
    }

    return { initialDealerships, initialPermissionsMap };
}

function compareMaps(
    map1: Map<string, Array<string>>,
    map2: Map<string, Array<string>>,
): boolean {
    if (map1.size !== map2.size) {
        return false;
    }

    for (const [key, value] of map1) {
        if (!map2.has(key) || !arraysEqual(value, map2.get(key)!)) {
            return false;
        }
    }

    for (const [key, value] of map2) {
        if (!map1.has(key) || !arraysEqual(value, map1.get(key)!)) {
            return false;
        }
    }

    return true;
}

function arraysEqual(arr1: Array<string>, arr2: Array<string>): boolean {
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (const item of arr1) {
        if (!arr2.includes(item)) {
            return false;
        }
    }

    return true;
}

export default Form;
